import React, { useState } from 'react';
import Edenredmodal from '@pages/DesignSystem/Edenredmodal';

const useC3PayReplacementPopup = () => {
	const [visible, setVisible] = useState(false);

	const show = () => setVisible(true);
	const hide = () => setVisible(false);

	const popup = (
		<Edenredmodal
			isOpen={visible}
			textcenter={true}
			title="Card Replacement via C3Pay Only"
			desc={
				<>
					<span>As per UAE Central Bank regulation, card replacement requests must be initiated by the account holder via the C3Pay app.</span>
					<br />
					<br />
					<span>Please ask the account holder to navigate to the profile section in the C3Pay app to request a card replacement.</span>
				</>
			}
			onOkay={hide}
			onOkayButton="Understood"
		/>
	);

	return { show, popup };
};

export default useC3PayReplacementPopup;
